import './remos/style';
import FormStructure from './remos/form_structure';

export default FormStructure;